// src/features/monetize/useMonetizeCatalog.ts

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { MONETIZE_QUERY_KEYS } from '@/lib/constants/monetize';
import { MonetizeApi } from './MonetizeApi';
import { useMonetizeEligibility } from './useMonetizeEligibility';

/** The selected account's products, offers and the access rules they imply. */
export function useMonetizeCatalog() {
  const { selectedCId } = useAuth();
  const { eligible } = useMonetizeEligibility();
  const query = useQuery({
    queryKey: MONETIZE_QUERY_KEYS.catalog(selectedCId ?? 0),
    queryFn: () => MonetizeApi.getCatalog(selectedCId!),
    enabled: eligible && selectedCId != null,
    staleTime: 30 * 1000,
  });
  return { catalog: query.data, isLoading: query.isLoading, isError: query.isError, error: query.error, refetch: query.refetch };
}
